<div class="flex shrink-0 items-center gap-1.5">
  @if (contactId(); as cid) {
    <app-iniciar-conversa-button
      [contactId]="cid"
      [compact]="true"
      [excludeChannelAccountId]="store.selectedConversation()?.channelAccountId ?? null"
    />
    <app-contact-link-actions [contactId]="cid" [contactName]="contactName()" [compact]="true" />
  }

  <button
    appUiIconButton
    variant="soft"
    size="sm"
    type="button"
    aria-label="Atribuir conversa"
    title="Atribuir"
    (click)="openAssigneePicker()"
  >
    <ng-icon name="heroUserPlus" size="16" aria-hidden="true" />
  </button>

  <div *appIfPermission="'conversations:base:snooze'" class="action-popover">
    <button
      #snoozeTrigger="ngpMenuTrigger"
      appUiIconButton
      variant="soft"
      size="sm"
      type="button"
      aria-label="Pausar conversa"
      title="Pausar"
      [ngpMenuTrigger]="snoozeMenu"
      ngpMenuTriggerPlacement="bottom-end"
    >
      <ng-icon name="heroPauseCircle" size="16" aria-hidden="true" />
    </button>
    <ng-template #snoozeMenu>
      <div appMenuPanel class="action-menu" role="menu">
        <button type="button" appMenuItem role="menuitem" (click)="snoozePreset('in-1h')">Pausar 1 hora</button>
        <button type="button" appMenuItem role="menuitem" (click)="snoozePreset('in-4h')">Pausar 4 horas</button>
        <button type="button" appMenuItem role="menuitem" (click)="snoozePreset('tomorrow')">Amanhã às 9h</button>
        <button type="button" appMenuItem role="menuitem" (click)="snoozePreset('next-week')">Próxima semana</button>
      </div>
    </ng-template>
  </div>

  <div class="action-popover">
    <button
      #moreTrigger="ngpMenuTrigger"
      appUiIconButton
      variant="soft"
      size="sm"
      type="button"
      aria-label="Prioridade e mais"
      title="Prioridade"
      [ngpMenuTrigger]="moreMenu"
      ngpMenuTriggerPlacement="bottom-end"
    >
      <ng-icon name="heroFlag" size="16" aria-hidden="true" />
    </button>
    <ng-template #moreMenu>
      <div appMenuPanel class="action-menu" role="menu">
        <div *appIfPermission="'conversations:base:change_priority'" class="action-menu__group">
          <span class="action-menu__label">Prioridade</span>
          @for (priority of priorities; track priority) {
            <button type="button" appMenuItem role="menuitem" (click)="changePriority(priority)">{{ priorityLabel(priority) }}</button>
          }
        </div>
        <ng-container *appIfPermission="'conversations:base:archive'">
          <div appMenuSeparator></div>
          <button type="button" appMenuItem tone="danger" role="menuitem" (click)="requestArchive()">Arquivar</button>
        </ng-container>
      </div>
    </ng-template>
  </div>

  <button
    *appIfPermission="'crm:deals:write'"
    appButton
    variant="secondary"
    size="sm"
    type="button"
    title="Criar oportunidade para o contato"
    [disabled]="loadingPipelines()"
    (click)="openCreateDeal()"
  >
    <ng-icon name="heroBriefcase" size="14" aria-hidden="true" />
    Criar oportunidade
  </button>

  @if (store.canReopen()) {
    <button *appIfPermission="'conversations:base:reopen'" appButton variant="primary" size="sm" type="button" (click)="reopen()">
      Reabrir
    </button>
  } @else {
    <button *appIfPermission="'conversations:base:resolve'" appButton variant="primary" size="sm" type="button" (click)="resolve()">
      Resolver
    </button>
  }
</div>

@if (dealDrawerOpen()) {
  <app-ui-detail-drawer [open]="true" title="Nova oportunidade" (closed)="closeDealDrawer()">
    <app-deal-form
      [pipelines]="pipelines()"
      [defaultPipelineId]="defaultPipelineId"
      [defaultContactId]="dealContactId()"
      (saved)="onDealSaved()"
      (cancelled)="closeDealDrawer()"
    />
  </app-ui-detail-drawer>
}

@if (confirmArchiveOpen()) {
  <div appDialogOverlay>
    <button appUiBackdropButton class="absolute inset-0" type="button" aria-label="Cancelar" (click)="confirmArchiveOpen.set(false)"></button>
    <section appDialog class="confirm-card relative z-10" aria-labelledby="archive-dialog-title" aria-describedby="archive-dialog-description" [ngpDialogModal]="true">
      <h2 appDialogTitle id="archive-dialog-title" class="confirm-card__title">Arquivar conversa</h2>
      <p appDialogDescription id="archive-dialog-description" class="confirm-card__body">A conversa sai das caixas de entrada padrão e não reabre com novas mensagens. O histórico é preservado.</p>
      <div class="confirm-card__actions">
        <button appButton variant="secondary" size="sm" type="button" (click)="confirmArchiveOpen.set(false)">Cancelar</button>
        <button appButton variant="primary" size="sm" type="button" (click)="confirmArchive()">Arquivar</button>
      </div>
    </section>
  </div>
}

@if (assigneeOpen()) {
  <app-assignee-picker-modal (closed)="closeAssigneePicker()" />
}
